module.exports = __webpack_public_path__ + "static/media/logo.523ba224.png";